import SchedulePageContainer from "components/pages/schedule/SchedulePageContainer";
import React from "react";
import ReactExt from "utils/ReactExt";

function Home() {
  return <SchedulePageContainer />;
}

export default React.memo(Home, ReactExt.checkPropsForReRender);
